import { createSlice } from "@reduxjs/toolkit";
import { getTaxonomyEntityName } from "../../utils/taxonomyFields";

const initialState = {
    list: [],
    selected: {},
    selectedId: undefined,
    isLoaded: false
};

const extractCategoryArray = (payload) => {
    if (!payload) return [];
    if (Array.isArray(payload)) return payload;
    if (Array.isArray(payload.data)) return payload.data;
    if (Array.isArray(payload?.data?.data)) return payload.data.data;
    if (Array.isArray(payload.result)) return payload.result;
    if (Array.isArray(payload.items)) return payload.items;
    return [];
};

const normalizeCategoryItem = (item) => {
    if (!item || typeof item !== "object") return item;
    const title = getTaxonomyEntityName(item) || getTaxonomyEntityName(item?.branch) || "";
    const id =
        item.id ??
        item.Id ??
        item.ID ??
        item.specialtyId ??
        item.SpecialtyId ??
        item.specialtyCategoryId ??
        item?.branch?.id ??
        item?.branch?.Id;

    return {
        ...item,
        id,
        name: item.name ?? item.Name ?? title,
        title
    };
};

const categorySlice = createSlice({
    name: 'category',
    initialState,
    reducers: {
        setCategories: (state, { payload }) => {
            state.list = extractCategoryArray(payload).map(normalizeCategoryItem);
            state.isLoaded = true;
        },
        addCategoryToList: (state, { payload }) => {
            state.list = [normalizeCategoryItem(payload), ...state.list];
        },
        updateCategoryList: (state, { payload }) => {
            state.list = state.list.map(item =>
                item.id === payload.id ? normalizeCategoryItem({ ...item, ...payload }) : item
            );
        },
        removeCategoryFromList: (state, { payload }) => {
            state.list = state.list.filter(item => item.id !== payload);
        },
        setSelectedCategory: (state, { payload }) => {
            state.selected = normalizeCategoryItem(payload);
        },
        clearSelectedCategory: (state) => {
            state.selected = {};
        },
        setSelectedBranchId: (state, { payload }) => {
            state.selectedId = payload;
        },
        clearSelectedBranchId: (state) => {
            state.selectedId = null;
        }
    }
});

export const {
    setCategories,
    addCategoryToList,
    updateCategoryList,
    removeCategoryFromList,
    setSelectedCategory,
    clearSelectedCategory,
    setSelectedBranchId,
    clearSelectedBranchId
} = categorySlice.actions;
export default categorySlice.reducer;